import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "postpayment.m" */ "./Loadable"));
